import InsightsInsightHeader from './InsightsInsightHeader';

export default InsightsInsightHeader;
